import React from 'react';
import type { AppProps } from 'next/app';
import { css, MAGNETIC_TOKENS } from '@appd/uik';
// @ts-ignore: Temporarily ignored until the @appd/fso-dashify package resolves its type issues.
import { DashboardContextProvider } from '@appd/fso-dashify';
import '@appd/fso-dashify/styles/globals.css';
import { AppContent, AppPageProps } from '../components/AppContent';
import { APP_ID } from '../modules/core/constants';

const {
  COLORS: { DEFAULT_BG, DEFAULT_TEXT },
  PARTICLE: { COLOR_SCHEME },
  TYPOGRAPHY: { BODY },
} = MAGNETIC_TOKENS;

css.RENDERER.renderStatic(
  {
    ...BODY.DEFAULT,
    backgroundColor: DEFAULT_BG,
    color: DEFAULT_TEXT,
    colorScheme: COLOR_SCHEME,
    height: '100%',
    margin: 0,
    padding: 0,
  },
  `body#${APP_ID}`,
);

export default ({
  Component,
  pageProps: { ...pageProps },
  router: { basePath },
}: AppProps<AppPageProps>): JSX.Element => (
  <DashboardContextProvider>
    <AppContent Component={Component} pageProps={pageProps} basePath={basePath} />
  </DashboardContextProvider>
);
